import { Component, EventEmitter, Output, Input } from '@angular/core';
import { PageEvent, Sort } from '@angular/material';
import { CampaignSummary, PaginationInfo } from 'src/app/campaigns/campaign';

@Component({
  selector: 'app-live-campaigns-summary',
  templateUrl: './live-campaigns-summary.component.html',
  styleUrls: ['./live-campaigns-summary.component.scss']
})
export class LiveCampaignsSummaryComponent {
  @Input() campaigns: CampaignSummary[];
  @Input() pagination: PaginationInfo;
  @Input() loading: boolean;
  @Output() viewCampaign = new EventEmitter<CampaignSummary>();
  @Output() paginationEvent = new EventEmitter<PageEvent>();
  @Output() sortEvent = new EventEmitter<Sort>();
  @Output() refreshEvent = new EventEmitter<void>();

  tableColumns: string[] = ['id', 'brand', 'campaignType', 'name', 'createdBy', 'validFrom', 'validTo'];

  get showTable(): boolean {
    return this.campaigns && this.campaigns.length > 0;
  }

  constructor() { }

  viewSelectedCampaign(campaign: CampaignSummary): void {
    this.viewCampaign.emit(campaign);
  }

  paginationAction(pageEvent: PageEvent): void {
    this.paginationEvent.emit(pageEvent);
  }

  sortData(sort: Sort): void {
    this.sortEvent.emit(sort);
  }

  refresh(): void {
    this.refreshEvent.emit();
  }
}
